import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import passwordApi from "~/backend/passwordApi";
import {pushWithAbsoluteLinks} from "~/actions/navigation_actions";


const { reduce, execute, types, } = createSuccessPromiseThunk({
    func: async ({password, passwordConfirmation, getConfig, getTranslator, getState}) => {
        if (!password || !passwordConfirmation) {
            const trans = getTranslator();
            return { friendly_error: trans("resetPasswordPage.noCredentials") };
        }

        const token = getState().router.query.resetToken;
        return passwordApi.updatePassword(getConfig().baseUrl, {password, passwordConfirmation, token});
    },
    name: 'updatePassword',
    successHandler: ({value, dispatch, setValue, setErrored, customParams}) => {
        if (!!value.success) {
            dispatch(setValue(value, customParams));
            dispatch(pushWithAbsoluteLinks("/"))
            return true;
        }

        dispatch(setErrored(value.friendly_error, customParams));
        return true;
    }
});

export { types as AUTH_TYPES, reduce as reduceUpdatePassword, execute as updatePassword };
